





































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { Action, namespace } from "vuex-class";

@Component
export default class AddPracticeForm extends Vue {
  @(namespace("practices").Action("createPractice")) actionCreatePractice: any;
  valid: boolean = false;
  name: any = "";
  email: any = "";
  url: any = "";
  emailRules: any = [
    (v: any) => !!v || "E-mail is required",
    (v: any) =>
      /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
      "E-mail must be valid",
  ];
  nameRules: any = [(v: any) => !!v || "Field is required"];

  resetState() {
    this.name = '';
    this.email = '';
    this.url = '';
  }

  toggleDialog() {
    this.resetState();
    this.$root.$emit("toggleDialog");
  }

  async createPractice() {
    const { name, email, url } = this;

    try {
      let results = await this.actionCreatePractice({
        name,
        email,
        url,
      });
      this.toggleDialog();
    } catch (err) {
      console.log(err);
      this.toggleDialog();
    }
  }
}
